// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__m-yAV","title":"FrontImage_title__31jDK"};